export default __webpack_public_path__ + "static/media/moSOLID.4a75c801.svg";